namespace Areas.Dialogs {
    "use strict";

    export class CreateBudgetDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateBudget", closeHandler, parameters, () => {
                const form = $("#CreateBudgetForm").dxForm("instance");
                const formData: any = form.option("formData");

                formData.AccountId = parameters.AccountId;
                formData.Project = parameters.Project;
        
                form.option("formData", formData);

                let addBC = parameters.AddBC;
                let disableGrid = true;
                if (addBC) {
                    disableGrid = false;
                }

                const templateGrid = $("#CreateBudgetGrid").dxDataGrid("instance");
                templateGrid.option("disabled", disableGrid);
            });
        }

        protected ok = (e: any) => {
            const form = $("#CreateBudgetForm").dxForm("instance");
            const result: any = form.validate();

            const dataGrid = $(`#CreateBudgetGrid`).dxDataGrid('instance');
            if (dataGrid.option("disabled") != true) {

                const selectedRows: any = dataGrid.getSelectedRowsData();

                if (selectedRows[0] == null) {
                    DevExpress.ui.notify("Please make a template selection first!", "warning", 2000);
                    return;
                } else {
                    let newData: any = form.option("formData");
                    newData.TemplateAccountId = selectedRows[0].accountId;


                    sendRequest("/Dialog/CreateBudget/Post", JSON.stringify(newData), "POST");
                }
            

            } else {

                if (result.isValid) {


                    let newData: any = form.option("formData");
                    newData.TemplateAccountId = 0;
                    sendRequest("/Dialog/CreateBudget/Post", JSON.stringify(newData), "POST");
                }
            }
        }
    }


    //account Lookup with status
    export function accountLookupItemWithStatus(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:700px;"><span class="collookupspan" style="width:550px;">${itemData.projectCCNumberName}</span>${itemData.accountStatusLk}</div>`);


    }

    export function onAccountSelectionChanged(e) {
        if (e.selectedItem != null) {

            let accountId = e.selectedItem.accountId;
            const method = "GET";
            let url = `/Budget/List/CheckForBudgetAccountCategoriesForAccountId`;

            const templateGrid = $("#CreateBudgetGrid").dxDataGrid("instance");

            $.get(`${url}/${accountId}`,
                (data) => {
                    if (data.length > 0) {
                        templateGrid.option("disabled", true);
                    }
                    else {
                        templateGrid.option("disabled", false);
                    }

                });
        }
    }

   

}
